// Global error handler for managing application-wide error states
class GlobalErrorHandler {
  private static instance: GlobalErrorHandler;
  private serverMaintenanceCallback:
    | ((isActive: boolean, message?: string) => void)
    | null = null;

  private constructor() {}

  static getInstance(): GlobalErrorHandler {
    if (!GlobalErrorHandler.instance) {
      GlobalErrorHandler.instance = new GlobalErrorHandler();
    }
    return GlobalErrorHandler.instance;
  }

  // Register the callback from the ErrorProvider
  setServerMaintenanceCallback(
    callback: (isActive: boolean, message?: string) => void
  ) {
    this.serverMaintenanceCallback = callback;
  }

  // Trigger server maintenance mode
  triggerServerMaintenance(message?: string) {
    if (this.serverMaintenanceCallback) {
      this.serverMaintenanceCallback(true, message);
    }
  }

  // Clear server maintenance mode
  clearServerMaintenance() {
    if (this.serverMaintenanceCallback) {
      this.serverMaintenanceCallback(false);
    }
  }

  // Handle HTTP errors - only show maintenance for 521 errors from webappinit
  handleHttpError(error: any) {
    // Check if it's a 521 error from webappinit endpoint
    if (error?.response?.status === 521 || error?.status === 521) {
      // Check if the request was to webappinit endpoint
      const isWebappInitRequest =
        error?.config?.url?.includes("/api/webapp/init") ||
        error?.request?.responseURL?.includes("/api/webapp/init");

      if (isWebappInitRequest) {
        this.triggerServerMaintenance(
          "Server is currently under maintenance. Please try again in a few minutes."
        );
        return true; // Indicates the error was handled
      }
    }

    return false; // Error was not handled
  }
}

export const globalErrorHandler = GlobalErrorHandler.getInstance();
